import{customAlphabet as o}from"nanoid";export{nanoid as default}from"nanoid";const n=o("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",8);export{n as numAlphNanoid};
//# sourceMappingURL=nanoid.js.map
